import { connect, ConnectedProps } from "react-redux";
import { AppState } from "../../../../redux/reducers";
import * as ImputationsStore from "../../../../redux/middleware/CashFlow-PaymentImputations.Middleware";
import { PaymentImputation } from "../../../../models/Entities/CashFlow/Payment/PaymentImputation";

export interface IProps {
    paymentId: number;
    showTitle?: boolean;
}

const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    imputations: state.CashFlowPaymentImputations?.imputations ?? [] as PaymentImputation[],
    isLoadingImputations: state.CashFlowPaymentImputations?.isLoadingImputations ?? false,
    successLoadingImputations: state.CashFlowPaymentImputations?.successLoadingImputations,
    failOnLoadingImputations: state.CashFlowPaymentImputations?.failOnLoadingImputations ?? false,
    isRollingBack: state.CashFlowPaymentImputations?.isRollingBack ?? false,
    successRollingBack: state.CashFlowPaymentImputations?.successRollingBack,
    failOnRollingBack: state.CashFlowPaymentImputations?.failOnRollingBack ?? false,
    isCreatingImputation: state.CashFlowPaymentImputations?.isCreatingImputation ?? false,
    successCreatingImputation: state.CashFlowPaymentImputations?.successCreatingImputation,
    failOnCreatingImputation: state.CashFlowPaymentImputations?.failOnCreatingImputation ?? false,
    error: state.CashFlowPaymentImputations?.error
});

const mapDispatchToProps = { ...ImputationsStore.actionCreators };

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = IProps & ConnectedProps<typeof connector>;
